<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="[getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <v-slider
      :name="schema.model"
      :id="generateId(schema.model)"
      :rules="rules"
      :value="schema.value"
      v-bind="schema.attributes"
      :disabled="schema.readonly"
      v-model="value"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      @click:append="zoomIn"
      @click:prepend="zoomOut"
      :iat-step="schema.attributes.step"
    >
      <template v-slot:label>
        {{ schema.attributes.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-slider>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  data() {
    return {
      required: v => v === 0 && `Este campo é obrigatório`
    };
  },

  mounted() {
    console.log(this.schema.value);
  },

  methods: {
    onChange: async function () {
      this.changeEvents();
    },
    zoomOut() {
      this.value = this.value - 10 || 0;
    },
    zoomIn() {
      this.value = this.value + 10 || 100;
    }
  }
};
</script>
